'use client';

import { useCallback, useMemo } from 'react';
import type { Cookie, Treasurer } from '@personly/libs-types';
import CookieExpires from '@/components/cookie-expires';
import CookieService from '@/components/cookie-service';
import Table from '@/components/table';
import { useConsents } from '@/providers/consents';
interface Props {
  cookies: Array<Cookie>;
  placeholder: string;
  treasurer: Treasurer;
}
const CookiesTable = ({
  cookies,
  placeholder,
  treasurer
}: Props) => {
  const {
    selectedCookieType
  } = useConsents();
  const dimensions = useMemo(() => [{
    header: 'Name',
    axis: 'name',
    width: 15
  }, {
    header: 'Service',
    axis: 'service',
    width: 20
  }, {
    header: 'Expires',
    axis: 'expires',
    width: 10
  }, {
    header: 'Description',
    axis: 'body',
    width: 55
  }], []);
  const transform = useCallback((cookie: Cookie, axis: keyof typeof cookie) => {
    if (axis === 'service') return <CookieService cookie={cookie} treasurer={treasurer} />;
    if (axis === 'expires') {
      const value = cookie.expires!;
      const days = Number.parseInt(value);
      const interval = Date.now() - days * 24 * 60 * 60 * 1000;
      return <CookieExpires days={days} interval={interval} placeholder={placeholder} />;
    }
    if (axis === 'body') return <div className="pl-2 md:pl-0 text-right md:text-left">
            {cookie[axis]}
          </div>;
    return cookie[axis] as string;
  }, [placeholder, treasurer]);
  const map = useCallback((cookie_0: Cookie) => ({
    data: dimensions.map(dimension => ({
      ...dimension,
      value: transform(cookie_0, dimension.axis as keyof typeof cookie_0)
    }))
  }), [dimensions, transform]);
  const data = useMemo(() => cookies.filter(({
    typeHandle
  }) => typeHandle === selectedCookieType.handle).map(map), [cookies, map, selectedCookieType]);
  return <Table dimensions={dimensions} data={data} />;
};
export default CookiesTable;